import { defineCustomElements } from '@duetds/date-picker/dist/esm/loader';

export default async function initDuetDatePicker() {
  const today = new Date().toISOString().split('T')[0];

  // Capture icons before defineCustomElements upgrades and clears children
  const icons = new Map();
  document.querySelectorAll('duet-date-picker').forEach((picker) => {
    const svg = picker.querySelector('svg');
    if (svg) icons.set(picker, svg.outerHTML);
    if (picker.hasAttribute('data-min-today')) picker.setAttribute('min', today);
  });

  await defineCustomElements(window);

  icons.forEach((iconHTML, picker) => {
    picker.componentOnReady().then(() => {
      const locale = picker.dataset.locale || 'en-US';
      const customPlaceholder = picker.dataset.placeholder || '';

      picker.localization = {
        ...picker.localization,
        locale,
        placeholder: customPlaceholder,
      };

      const toggleIcon = picker.querySelector('.duet-date__toggle-icon');
      if (toggleIcon) toggleIcon.innerHTML = iconHTML;

      const originalSvg = picker.querySelector(':scope > svg');
      if (originalSvg) originalSvg.remove();

      const input = picker.querySelector('.duet-date__input');
      if (input) {
        input.addEventListener('blur', () => {
          if (!picker.value) input.placeholder = customPlaceholder;
        });
      }
    });
  });
}
